import {
	CLEAR_USER_MANAGEMENT_STATE,
	GET_ALL_USERS,
	GET_ALL_USERS_SUCCESS,
	GET_ALL_USERS_ERROR,
	GET_USER_BY_ID,
	GET_USER_BY_ID_SUCCESS,
	GET_USER_BY_ID_ERROR,
	GET_USER_ROLES,
	GET_USER_ROLES_SUCCESS,
	GET_USER_ROLES_ERROR,
	CREATE_USER,
	CREATE_USER_SUCCESS,
	CREATE_USER_ERROR,
	UPDATE_USER,
	UPDATE_USER_SUCCESS,
	UPDATE_USER_ERROR,
	DELETE_USER,
	DELETE_USER_SUCCESS,
	DELETE_USER_ERROR,
	GET_ALL_ORIGINATORS,
	GET_ALL_ORIGINATORS_SUCCESS,
	GET_ALL_ORIGINATORS_ERROR,
	GET_USER_STATUS,
	GET_USER_STATUS_SUCCESS,
	GET_USER_STATUS_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();

const USER_URL = '/users';
const USER_STATUS_URL = '/userStatus';
const ORIGINATOR_URL = '/originator';
const USER_ROLE_URL = '/user-role';

const defaultState = () => ({
	userList: [],
	isLoadingUsers: '',
	userRoleList: [],
	isLoadingUserRoles: '',
	originatorList: [],
	isLoadingOriginators: '',
	statusList: [],
	isLoadingUserStatus: '',
});

const state = defaultState();

const getters = {
	userList: (state) => state.userList,
	isLoadingUsers: (state) => state.isLoadingUsers === 'loading',
	userRoleList: (state) => state.userRoleList,
	isLoadingUserRoles: (state) => state.isLoadingUserRoles === 'loading',
	originatorList: (state) => state.originatorList,
	isLoadingOriginators: (state) => state.isLoadingOriginators === 'loading',
	statusList: (state) => state.statusList,
	isLoadingUserStatus: (state) => state.isLoadingUserStatus === 'loading',
};

const mutations = {
	[CLEAR_USER_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_USERS]: (state) => {
		state.isLoadingUsers = 'loading';
	},
	[GET_ALL_USERS_SUCCESS]: (state, data) => {
		state.userList = data;
		state.isLoadingUsers = 'success';
	},
	[GET_ALL_USERS_ERROR]: (state) => {
		state.isLoadingUsers = 'error';
	},
	[GET_USER_ROLES]: (state) => {
		state.isLoadingUserRoles = 'loading';
	},
	[GET_USER_ROLES_SUCCESS]: (state, data) => {
		state.userRoleList = data;
		state.isLoadingUserRoles = 'success';
	},
	[GET_USER_ROLES_ERROR]: (state) => {
		state.isLoadingUserRoles = 'error';
	},
	[GET_USER_BY_ID]: (state) => {
		state.isLoadingUsers = 'loading';
	},
	[GET_USER_BY_ID_SUCCESS]: (state, data) => {
		state.isLoadingUsers = 'success';
	},
	[GET_USER_BY_ID_ERROR]: (state) => {
		state.isLoadingUsers = 'error';
	},
	[CREATE_USER]: (state) => {
		state.isLoadingUsers = 'loading';
	},
	[CREATE_USER_SUCCESS]: (state, data) => {
		state.isLoadingUsers = 'success';
	},
	[CREATE_USER_ERROR]: (state) => {
		state.isLoadingUsers = 'error';
	},
	[UPDATE_USER]: (state) => {
		state.isLoadingUsers = 'loading';
	},
	[UPDATE_USER_SUCCESS]: (state, data) => {
		state.isLoadingUsers = 'success';
	},
	[UPDATE_USER_ERROR]: (state) => {
		state.isLoadingUsers = 'error';
	},
	[DELETE_USER]: (state) => {
		state.isLoadingUsers = 'loading';
	},
	[DELETE_USER_SUCCESS]: (state, data) => {
		state.isLoadingUsers = 'success';
	},
	[DELETE_USER_ERROR]: (state) => {
		state.isLoadingUsers = 'error';
	},
	[GET_ALL_ORIGINATORS]: (state) => {
		state.isLoadingOriginators = 'error';
	},
	[GET_ALL_ORIGINATORS_SUCCESS]: (state, data) => {
		state.isLoadingOriginators = 'success';
		state.originatorList = data;
	},
	[GET_ALL_ORIGINATORS_ERROR]: (state) => {
		state.isLoadingOriginators = 'error';
	},
	[GET_USER_STATUS]: (state) => {
		state.isLoadingUserStatus = 'error';
	},
	[GET_USER_STATUS_SUCCESS]: (state, data) => {
		state.isLoadingUserStatus = 'success';
		state.statusList = data;
	},
	[GET_USER_STATUS_ERROR]: (state) => {
		state.isLoadingUserStatus = 'error';
	},
};

const actions = {
	[GET_ALL_USERS]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_USERS);
			localStorage.setItem(`lastReqAdm`, 'userManagement/GET_ALL_USERS');

			http({
				method: 'GET',
				url: `${USER_URL}/all-users${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_USERS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_USERS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_USER_ROLES]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_USER_ROLES);
			localStorage.setItem(`lastReqAdm`, 'userManagement/GET_USER_ROLES');

			http({
				method: 'GET',
				url: USER_ROLE_URL,
			})
				.then((response) => {
					resolve(response);
					commit(GET_USER_ROLES_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_USER_ROLES_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_USER_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_USER_BY_ID);

			http({
				method: 'GET',
				url: `${USER_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_USER_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_USER_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_USER]: async ({ commit }, { vm, body, timestamp }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_USER);

			http.defaults.headers.common.timestamp = timestamp;

			http({
				method: 'POST',
				url: `${USER_URL}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Usuário criado com sucesso.');
					commit(CREATE_USER_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_USER_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_USER]: async ({ commit }, { vm, id, body, timestamp }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_USER);

			http.defaults.headers.common.timestamp = timestamp;

			http({
				method: 'PATCH',
				url: `${USER_URL}/${id}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Usuário editado com sucesso.');
					commit(UPDATE_USER_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_USER_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_USER]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_USER);

			http({
				method: 'DELETE',
				url: `${USER_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Usuário excluído com sucesso.');
					commit(DELETE_USER_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_USER_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_ALL_ORIGINATORS]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_ORIGINATORS);

			http({
				method: 'GET',
				url: `${ORIGINATOR_URL}?limit=1000000&page=1`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_ORIGINATORS_SUCCESS, response.data.originators);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_ORIGINATORS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_USER_STATUS]: async ({ commit }, { vm }) => {
		return new Promise((resolve, reject) => {
			commit(GET_USER_STATUS);

			http({
				method: 'GET',
				url: USER_STATUS_URL,
			})
				.then((response) => {
					resolve(response);
					commit(GET_USER_STATUS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_USER_STATUS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
